// Settings reached from a docs or portal link are highlighted on arrival, then fade back.
.target {
  border-radius: var(--radius-md);
}

.target[data-highlighted] {
  animation: settingHighlight 2.4s ease-out forwards;
}

// A dialog covers the page (the Terms dialog on arrival): hold the highlight at full strength and
// start the fade once every dialog has closed.
.target[data-highlighted][data-highlight-held] {
  animation-play-state: paused;
}

@keyframes settingHighlight {
  0%,
  35% {
    background-color: var(--color-primary-soft);
    box-shadow: 0 0 0 12px var(--color-primary-soft);
  }

  100% {
    background-color: transparent;
    box-shadow: 0 0 0 12px transparent;
  }
}

// Without motion: hold the highlight, then remove it in one step.
@media (prefers-reduced-motion: reduce) {
  .target[data-highlighted] {
    animation-timing-function: steps(1, end);
  }
}
